import React, { useState, useEffect } from 'react';
import { useAuth } from '@/state/auth/AuthProvider';

export const NavigationDebug: React.FC = () => {
  const { user, isAuthenticated } = useAuth();
  const [token, setToken] = useState<string | null>(null);
  const [apiTest, setApiTest] = useState<string>('');

  useEffect(() => {
    const storedToken = localStorage.getItem('auth_token');
    setToken(storedToken);
  }, []);

  const testApiConnection = async () => {
    try {
      const response = await fetch('/api/v1/navigation/favorites', {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      
      if (response.ok) {
        const data = await response.json();
        setApiTest(`✅ API Connection Successful: ${JSON.stringify(data, null, 2)}`);
      } else {
        setApiTest(`❌ API Error: ${response.status} ${response.statusText}`);
      }
    } catch (error: any) {
      setApiTest(`❌ Connection Error: ${error.message}`);
    }
  };

  return (
    <div className="p-4 bg-gray-100 rounded-lg m-4">
      <h3 className="text-lg font-bold mb-4">Navigation Debug Info</h3>
      
      <div className="space-y-2">
        <div>
          <strong>User Authenticated:</strong> {isAuthenticated ? '✅ Yes' : '❌ No'}
        </div>
        
        <div>
          <strong>User Email:</strong> {user?.email || 'Not available'}
        </div>
        
        <div>
          <strong>Token Available:</strong> {token ? '✅ Yes' : '❌ No'}
        </div>
        
        <div>
          <strong>Token Preview:</strong> {token ? `${token.substring(0, 20)}...` : 'None'}
        </div>
        
        <button
          onClick={testApiConnection}
          className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
        >
          Test API Connection
        </button>
        
        {apiTest && (
          <div className="mt-4 p-2 bg-white rounded border">
            <strong>API Test Result:</strong>
            <pre className="text-xs mt-2 overflow-auto max-h-40">{apiTest}</pre>
          </div>
        )}
      </div>
    </div>
  );
};
